@use 'MapModal';
@use 'ui-dock';
@use 'ui-timeline';
@use 'hotspots';
@use 'hotspot-tooltip';

body {
  /* Prevent scrolling for the VR app */
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #000;
}
